module.exports = {
      id: "gzhome-usage",
      viewBox: "0 0 29.037 17.12",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#gzhome",
      toString: function () {
        return this.url;
      }
    }